"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThrowStateType = void 0;
var models_1 = require("@kcutils/models");
var helper_1 = require("@kcutils/helper");
var ThrowStateType;
(function (ThrowStateType) {
    ThrowStateType[ThrowStateType["WARN"] = 0] = "WARN";
    ThrowStateType[ThrowStateType["ERROR"] = 1] = "ERROR";
})(ThrowStateType = exports.ThrowStateType || (exports.ThrowStateType = {}));
var randomCode = function () {
    var digit = 8;
    var rand = Math.random();
    var multiply = Math.pow(10, digit);
    return Math.ceil(rand * multiply);
};
var ThrowState = /** @class */ (function () {
    function ThrowState(type, code, name) {
        this.id = ThrowState.counter;
        ThrowState.increase();
        if (helper_1.generic.isExist(type))
            this.type = type;
        else
            this.type = ThrowStateType.ERROR;
        if (helper_1.generic.isExist(code))
            this.code = code;
        else
            this.code = randomCode();
        if (helper_1.generic.isExist(name))
            this.name = name;
        else
            this.name = "";
    }
    ThrowState.increase = function () {
        ThrowState.counter++;
    };
    ThrowState.prototype.copy = function (input) {
        var type = new models_1.Optional(input === null || input === void 0 ? void 0 : input.type).getOrElse(this.type);
        var code = new models_1.Optional(input === null || input === void 0 ? void 0 : input.code).getOrElse(this.code);
        var name = new models_1.Optional(input === null || input === void 0 ? void 0 : input.name).getOrElse(this.name);
        return new ThrowState(type, code, name);
    };
    ThrowState.prototype.getId = function () {
        return this.id;
    };
    ThrowState.prototype.next = function (name) {
        var code = this.code + 1;
        return this.copy({ code: code, name: name });
    };
    /**
     * check identical object id
     * @param s any throw status object
     */
    ThrowState.prototype.equals = function (s) {
        return this.id === s.id;
    };
    ThrowState.counter = 0;
    return ThrowState;
}());
exports.default = ThrowState;
//# sourceMappingURL=state.js.map